import { cn } from '@gettactic/helpers';
import React from 'react';
import { Box } from '../../primitives';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetTitle
} from '../../primitives/Sheet';
import { DrawerProps } from './Drawer.types';

export const Drawer: React.FC<DrawerProps> = ({
  children,
  title,
  description,
  onOpenChange,
  className,
  isOpen,
  footer
}) => {
  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      <SheetContent
        className={cn('flex h-full w-full flex-grow flex-col', className)}
      >
        <SheetHeader>{title && <SheetTitle>{title}</SheetTitle>}</SheetHeader>
        {description && <SheetDescription>{description}</SheetDescription>}
        <Box className={'relative h-full w-full flex-grow overflow-auto p-6'}>
          {children}
        </Box>
        {!!footer && (
          <SheetFooter
            className={'items-center justify-between border-t px-6 py-4'}
          >
            {footer}
          </SheetFooter>
        )}
      </SheetContent>
    </Sheet>
  );
};
